import axios from 'axios'
import {EntityDto} from '../../../../../../../services/dto/entityDto'
import CreateGraduatedDocument from './dto/CreateGraduatedDocument'
import GetAllGraduatedDocuments from './dto/GetAllGraduatedDocuments'
import UpdateGraduatedDocument from './dto/UpdateGraduatedDocument'
import GetGraduatedDocument from './dto/GetGraduatedDocument'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/GraduatedDocument/Create`
export const URL_DELETE = `${API_URL}/GraduatedDocument/Delete`
export const URL_GET = `${API_URL}/GraduatedDocument/Get`
export const URL_GET_BY_GRADUATED_ID = `${API_URL}/GraduatedDocument/GetByGraduatedId`
export const URL_UPDATE = `${API_URL}/GraduatedDocument/Update`
export const URL_GET_BY_USER_ID = `${API_URL}/GraduatedDocument/GetByGraduatedId`

export function onCreateGraduatedDocument(
  createGraduatedDocument: CreateGraduatedDocument
): Promise<boolean> {
  return axios.post(URL_CREATE, createGraduatedDocument)
}

export function onDeleteGraduatedDocument(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetGraduatedDocumentsByGraduationId(
  user: EntityDto
): Promise<GetGraduatedDocument> {
  return axios.get(URL_GET_BY_USER_ID, {params: user})
}

export function onGetGraduatedDocument(entityDto: EntityDto): Promise<GetGraduatedDocument> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetGraduatedDocumentByGraduatedId(
  graduated: EntityDto
): Promise<GetAllGraduatedDocuments> {
  return axios.get(URL_GET_BY_GRADUATED_ID, {params: graduated})
}

export function onUpdateGraduatedDocument(
  updateGraduatedDocumentInput: UpdateGraduatedDocument
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateGraduatedDocumentInput)
}
